import { ReactComponent as ProductIcon } from "icons/product.svg";
import { ReactComponent as SettingsIcon } from "icons/settings.svg";
import { ReactComponent as ShopIcon } from "icons/shop.svg";

const getNav = ({
  permission_display_purchase_price,
  permission_workflow_worker_view,
  permission_workflow_admin_view,
  permission_campaigns_view,
}) => [
  {
    name: "Sprzedaż",
    type: "group",
    icon: <ShopIcon />,
    items: [
      { name: "Platformy", path: "/platforms" },
      { name: "Sklepy", path: "/shops" },
      { name: "Kanały", path: "/channels" },
      { name: "Stawki VAT", path: "/vat_rates" },
      { name: "Waluty", path: "/currencies" },
    ],
  },
  {
    name: "Katalog",
    type: "group",
    icon: <ProductIcon />,
    items: [
      { name: "Produkty grupowe", path: "/product_groups" },
      { name: "Produkty", path: "/products" },
      { name: "Zarządzanie produktami", path: "/products_manage" },
      {
        name: "Kategorie platform",
        path: "/platforms/platform_taxons",
      },
      {
        name: "Kategorie root",
        path: "/root_taxons",
      },
      { name: "Właściwości", path: "/properties" },
      { name: "Prototypy", path: "/prototypes" },
      { name: "Producenci", path: "/producers" },
      { name: "Marki", path: "/brands" },
      { name: "Oferty bez produktu", path: "/empty_offers" },
      (permission_workflow_worker_view || permission_workflow_admin_view) && {
        name: "Statusy produktów",
        path: "/workflows",
      },
    ].filter(Boolean),
  },
  {
    name: "Analiza",
    type: "group",
    icon: <ShopIcon />,
    items: [
      permission_display_purchase_price && {
        name: "Analiza",
        path: "/analyze",
      },
      permission_campaigns_view && {
        name: "Kampanie reklamowe",
        path: "/campaigns",
      },
    ].filter(Boolean),
  },
  {
    name: "Zarządzanie",
    type: "group",
    icon: <SettingsIcon />,
    items: [
      {
        name: "Ustawienia sprzedaży",
        path: "/settings",
      },
    ],
  },
];

export default getNav;
